import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { dealersApi } from '../features/dealer';
import dealerReducer from '../features/dealer/dealer-slice.ts';
import { geographicApi } from '../features/geographic';
import { locationsApi } from '../features/location';
import { manufacturersApi } from '../features/manufacturer';
import manufacturerReducer from '../features/manufacturer/manufacturer-slice';
import { messagingApi } from '../features/messaging';
import { ordersApi } from '../features/order';
import orderReducer from '../features/order/order-slice';
import { paintDataApi } from '../features/paint-data/paint-data-api-slice';
import { priceManagementApi } from '../features/price-management';
import { systemSettingsApi } from '../features/settings/system-settings-api-slice';
import { techniciansApi } from '../features/technician';
import { taskTrackersApi } from '../features/traveler';
import { usersApi } from '../features/user';
import { workOrderTravelerApi } from '../features/work-order-traveler';
import userReducer from '../features/user/user-slice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    manufacturer: manufacturerReducer,
    dealer: dealerReducer,
    order: orderReducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [manufacturersApi.reducerPath]: manufacturersApi.reducer,
    [dealersApi.reducerPath]: dealersApi.reducer,
    [geographicApi.reducerPath]: geographicApi.reducer,
    [techniciansApi.reducerPath]: techniciansApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [systemSettingsApi.reducerPath]: systemSettingsApi.reducer,
    [paintDataApi.reducerPath]: paintDataApi.reducer,
    [messagingApi.reducerPath]: messagingApi.reducer,
    [priceManagementApi.reducerPath]: priceManagementApi.reducer,
    [taskTrackersApi.reducerPath]: taskTrackersApi.reducer,
    [workOrderTravelerApi.reducerPath]: workOrderTravelerApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      usersApi.middleware,
      manufacturersApi.middleware,
      dealersApi.middleware,
      geographicApi.middleware,
      techniciansApi.middleware,
      ordersApi.middleware,
      locationsApi.middleware,
      systemSettingsApi.middleware,
      paintDataApi.middleware,
      messagingApi.middleware,
      priceManagementApi.middleware,
      taskTrackersApi.middleware,
      workOrderTravelerApi.middleware
    ),
});

// Optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
